// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"12c5068e","885":"3b20281d"}[chunkId] + ".chunk.js";
};